import { render, staticRenderFns } from "./PurchaseAveragePrice.vue?vue&type=template&id=12246bba&scoped=true&"
import script from "./PurchaseAveragePrice.vue?vue&type=script&lang=js&"
export * from "./PurchaseAveragePrice.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAveragePrice.vue?vue&type=style&index=0&id=12246bba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12246bba",
  null
  
)

export default component.exports